/** Shared QA priority scale — keep in sync with backend feedback-priorities.js */

export const FEEDBACK_PRIORITIES = [
	{
		value: 'showstopper',
		label: 'Showstopper',
		meaning: 'Cannot complete critical work; path fully unusable',
	},
	{
		value: 'high',
		label: 'High',
		meaning: 'Major impairment; workaround painful or unreliable',
	},
	{
		value: 'medium',
		label: 'Medium',
		meaning: 'Significant issue; reasonable workaround exists',
	},
	{
		value: 'low',
		label: 'Low',
		meaning: 'Minor inconvenience or polish',
	},
	{
		value: 'nice_to_have',
		label: 'Nice to have',
		meaning: 'Improvement when capacity allows',
	},
] as const;

export type FeedbackPriority = (typeof FEEDBACK_PRIORITIES)[number]['value'];

export const DEFAULT_FEEDBACK_PRIORITY: FeedbackPriority = 'medium';

export function feedbackPriorityLabel(priority: string | undefined): string {
	const match = FEEDBACK_PRIORITIES.find((p) => p.value === priority);
	return match?.label || priority || 'Medium';
}

export function feedbackPriorityOptionLabel(priority: (typeof FEEDBACK_PRIORITIES)[number]): string {
	return `${priority.label} - ${priority.meaning}`;
}
